import { Section } from '@ahmdigital/ui';
import styled from 'styled-components';

export const HeroContainer = styled.div`
  --hero-padding-x: 1rem;
  --hero-widget-padding-x: 1rem;
  --hero-bottom-padding: 2.5rem;
  --hero-content-max-width-md: 55rem;
  --hero-content-max-width-lg: 49rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    --hero-padding-x: 2.5rem;
    --hero-widget-padding-x: 0.5rem;
  }

  @media (min-width: ${({ theme }) => theme.media.lg}) {
    --hero-widget-padding-x: 2.5rem;
  }
`;

export const StyledSection = styled(Section)`
  ${({ theme }) => `
  padding: 2.5rem var(--hero-padding-x) 0;
  grid-column: 1 / span 3;

    @media (min-width: ${theme.media.md}) {
      max-width: var(--hero-content-max-width-md);
      padding: 6rem 0 0 var(--hero-padding-x);
    }

      @media (min-width: ${theme.media.lg}) {
        max-width: var(--hero-content-max-width-lg);
        grid-column: 1 / span 2;
        grid-row: 1;
      }
  `}

  .flair {
    .ctaLink {
      color: $color-purple;
    }
  }
`;

export const WidgetOfferSectionDesktopWrapper = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / span 3;
    z-index: 1;
  }
`;

export const WidgetOfferSectionMobileWrapper = styled.div`
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / span 3;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    display: none;
  }
`;

export const OfferSectionWrapper = styled.div<{ $hasOffer: boolean }>`
  grid-column: 1 / span 3;
  padding: ${({ $hasOffer }) => `0 var(--hero-padding-x) ${$hasOffer ? 'var(--hero-bottom-padding)' : '0'}`};

  section {
    padding-top: 1rem;
  }

  @media (min-width: ${({ theme }) => theme.media.md}) {
    max-width: var(--hero-content-max-width-md);
    padding: 0 0 0 var(--hero-padding-x);
    grid-row: 2;
  }

  @media (min-width: ${({ theme }) => theme.media.lg}) {
    max-width: var(--hero-content-max-width-lg);
    grid-column: 1 / span 2;
  }
`;

export const DesktopVideoWrapper = styled.div<{
  $extraTopMargin?: boolean;
  $isOfferSectionHidden: boolean;
}>`
  margin-top: ${({ $extraTopMargin }) => ($extraTopMargin ? '7rem' : '0')};
  text-align: center;
  width: 100%;
  position: absolute;
  transform: ${({ $extraTopMargin }) => ($extraTopMargin ? 'translate(-30%, 10%)' : 'translate(-35%, 10%)')};

  video {
    height: ${({ $isOfferSectionHidden }) => ($isOfferSectionHidden ? '400px' : '500px')};
    width: ${({ $isOfferSectionHidden }) => ($isOfferSectionHidden ? '300px' : '377px')};
    object-fit: contain;
  }
`;

export const WidgetWrapper = styled.div`
  grid-column: 1 / span 3;
  max-width: 100%;
  padding: 0 var(--hero-widget-padding-x);
  position: relative;

  @media (max-width: ${({ theme }) => theme.media.md}) {
    padding-top: var(--hero-bottom-padding);
    padding-bottom: var(--hero-bottom-padding);
  }

  @media (min-width: ${({ theme }) => theme.media.md}) {
    grid-row: 3;
  }

  @media (min-width: ${({ theme }) => theme.media.lg}) {
    padding: 0 var(--hero-widget-padding-x) var(--hero-bottom-padding);
  }
`;

export const ImageWrapper = styled.div`
  grid-column: 3;
  grid-row: 1 / span 2;
  position: relative;
  z-index: 0;
  display: none;

  @media (min-width: ${({ theme }) => theme.media.lg}) {
    display: block;
  }
`;

export const BorderBox = styled.div`
  border-bottom: 0.5rem solid ${({ theme }) => theme.colors.black};
  margin-inline: -1rem;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    border: 0.5rem solid ${({ theme }) => theme.colors.black};
    border-top: none;
  }
`;
